import axios, { AxiosResponse } from 'axios';
import { TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { TFormValues } from '../../types';
import { Row } from '../Row';

interface IProps {
    formValues: TFormValues;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

interface IPostcodeRequest {
    zipCode: string;
    houseNumber: string;
}

interface IPostcodeResponse {
    city: string;
    street: string;
}

export const AddressSection = ({ formValues, setFieldValue }: IProps) => {
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);

    const handleHouseNumberBlur = () => {
        if (
            !process.env.REACT_APP_POSTCODE_API_URL ||
            !formValues.zipcode ||
            !formValues.houseNumber
        )
            return;

        axios
            .post<IPostcodeRequest, AxiosResponse<IPostcodeResponse>>(
                process.env.REACT_APP_POSTCODE_API_URL,
                {
                    zipCode: formValues.zipcode,
                    houseNumber: formValues.houseNumber,
                }
            )
            .then((res) => {
                const { street, city } = res.data;

                setFieldValue('street', street);
                setFieldValue('city', city);
            });
    };

    return (
        <>
            <Row>
                <TextField
                    required
                    id={formValues.zipcode}
                    label="Postcode"
                    value={formValues.zipcode}
                    onChange={(e) => setFieldValue('zipcode', e.target.value)}
                />
                <TextField
                    required
                    id={formValues.houseNumber}
                    label="Huisnummer"
                    sx={{ margin: `${mediumBreakpoint && '0 10px'}` }}
                    value={formValues.houseNumber}
                    onBlur={handleHouseNumberBlur}
                    onChange={(e) =>
                        setFieldValue('houseNumber', e.target.value)
                    }
                />
                <TextField
                    id={formValues.houseNumberAddition}
                    label="Toevoeging"
                    value={formValues.houseNumberAddition}
                    onChange={(e) =>
                        setFieldValue('houseNumberAddition', e.target.value)
                    }
                />
            </Row>
            <TextField
                required
                id={formValues.street}
                label="Straat"
                value={formValues.street}
                onChange={(e) => setFieldValue('street', e.target.value)}
            />
            <TextField
                required
                id={formValues.city}
                label="Plaats"
                value={formValues.city}
                onChange={(e) => setFieldValue('city', e.target.value)}
            />
        </>
    );
};
